module.exports = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success',
};
